import { useState, useEffect } from "react";
import "../src/assets/components/global.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import AutoLogout from "./autologout";
import Swal from "sweetalert2";

function Listalluser() {
  const [adminData, setAdminData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setLastname] = useState("");
  const [age, setAge] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState("");
  const [cellnumber, setCellnumber] = useState("");
  const [civilstatus, setCivilstatus] = useState("Single");
  const [religion, setReligion] = useState("N/A");
  const [nationality, setNationality] = useState("");
  const [occupation, setOccupation] = useState("");
  const [recentaddress, setRecentaddress] = useState("");
  const [presentaddress, setPresentaddress] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("member"); // Default role is "member"
  const [selectedBrgyId, setSelectedBrgyId] = useState(null);
  const [status, setStatus] = useState("");
  // const [photo, setPhoto] = useState("");

  const navigate = useNavigate();
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [isSearchboxVisible, setSearchboxVisible] = useState(false);
  const [searchfname, setSearchfname] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/listalluser?firstname=${searchfname}`
      )
      .then((res) => {
        console.log(res.data);
        setAdminData(res.data);
      })
      .catch((err) => console.log(err));
  }, [searchfname]);

  const handleEdit = (userData) => {
    setIsEditVisible(!isEditVisible);
    setSearchboxVisible(!isSearchboxVisible);

    // Set text data to the desired textbox information to update
    setEditData(userData);
    setSelectedBrgyId(userData.brgyId);
    setUsername(userData.username);
    setEmail(userData.email);
    setPassword(userData.password);
    setRole(userData.role);
    setFirstname(userData.firstname);
    setMiddlename(userData.middlename);
    setLastname(userData.lastname);
    setAge(userData.age);
    setBirthdate(userData.birthdate);
    setGender(userData.gender);
    setCellnumber(userData.cellnumber);
    setCivilstatus(userData.civilstatus);
    setReligion(userData.religion);
    setNationality(userData.nationality);
    setOccupation(userData.occupation);
    setRecentaddress(userData.recentaddress);
    setPresentaddress(userData.presentaddress);
    setStatus(userData.status);
    // setPhoto(userData.photo);
    console.log("password:" + password);
    console.log("checkbdateformat:" + birthdate);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to continue",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, continue!",
    });
    if (result.isConfirmed) {
      const formattedBirthdate = new Date(birthdate)
        .toISOString()
        .split("T")[0];

      const updatedUserData = {
        brgyId: selectedBrgyId,
        firstname,
        middlename,
        lastname,
        age,
        birthdate: formattedBirthdate,
        gender,
        cellnumber,
        civilstatus,
        religion,
        nationality,
        occupation,
        recentaddress,
        presentaddress,
        username,
        email,
        password,
        role,
        status,
      };
      try {
        const response = await axios.put(
          `https://brgytracerappserver.onrender.com/listalluser/${selectedBrgyId}`,
          updatedUserData
        );
        if (response.data.status === "success") {
          await Swal.fire({
            title: "User Updated",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
          setIsEditVisible(!isEditVisible);
          setSearchboxVisible(!isSearchboxVisible);
          // Reload the page after successful update
          window.location.reload();
        }
      } catch (error) {
        console.error("Error updating data:", error);
        // Handle error...
      }
    }
  };

  const handleDelete = (brgyId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Send a DELETE request to the server to delete the user
        axios
          .delete(
            `https://brgytracerappserver.onrender.com/listalluser/${brgyId}`
          )
          .then((res) => {
            if (res.data.status === "success") {
              Swal.fire({
                title: "Deleted!",
                text: "User has been deleted!",
                icon: "success",
              });
            }
            // Update the adminData state to reflect the changes
            setAdminData((prevData) => {
              const updatedUsers = prevData.users.filter(
                (user) => user.brgyId !== brgyId
              );
              return { ...prevData, users: updatedUsers };
            });
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const handleCancel = () => {
    setFirstname("");
    setIsEditVisible(false);
    setEditData(null);
  };

  const handleClose = () => {
    navigate("/adminpage");
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(adminData.users.length / rowsPerPage))
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentUsers =
    adminData && adminData.users && adminData.users.slice(startIndex, endIndex);

  return (
    <div className="listalluser-parent parent-height">
      <AutoLogout />
      <div className="container">
        <div className={`searchbox ${isEditVisible ? "edit-mode" : ""}`}>
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={searchfname}
              onChange={(e) => setSearchfname(e.target.value)}
            />
          </div>
        </div>
        {!editData && (
          <div
            className={`datagrid-parent ${isEditVisible ? "edit-mode" : ""}`}>
            <button className="closebtn" type="button" onClick={handleClose}>
              X
            </button>
            <h1>List Active Users</h1>
            {currentUsers && currentUsers.length > 0 ? (
              <div className="datagrid-holder">
                <table>
                  <thead>
                    <tr>
                      <th>BrgyId</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.map((user) => (
                      <tr key={user.brgyId}>
                        <td>{user.brgyId}</td>
                        <td>{user.firstname}</td>
                        <td>{user.lastname}</td>
                        <td>{user.email}</td>
                        <td>{user.role}</td>
                        <td
                          className="handleEdit"
                          onClick={() => handleEdit(user)}>
                          View
                        </td>
                        <td
                          className="handleDelete"
                          onClick={() => handleDelete(user.brgyId)}>
                          Delete
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-controls">
                  <button
                    className="pagination-button"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}>
                    Previous
                  </button>
                  <span className="pagination-info">
                    Page {currentPage} of{" "}
                    {Math.ceil(adminData.users.length / rowsPerPage)}
                  </span>
                  <button
                    className="pagination-button"
                    onClick={handleNextPage}
                    disabled={
                      currentPage ===
                      Math.ceil(adminData.users.length / rowsPerPage)
                    }>
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <p className="noUsertext">No users available for display.</p>
            )}
          </div>
        )}
      </div>
      {/* Edit form */}
      {editData && (
        <div className="Updateform-parent wrap parentof-responsive">
          <div className="updateform-holder forresponsive">
            <h1>Update form</h1>
            <div className="autonumbers">
              <label>BrgyId:{selectedBrgyId}</label>
            </div>
            <form className="formUpdate-boxcontainers" onSubmit={handleUpdate}>
              <div className="photo-container">
                <img src={editData.photo} alt="User Photo" />
              </div>
              <label>Account Information</label>
              <div className="accountbox-container">
                <div>
                  <label htmlFor="username">Username:</label>
                  <input
                    type="text"
                    placeholder="Enter Username"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div>
                  <label>Email:</label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="password">Password:</label>
                  <input
                    type="password"
                    placeholder="Enter Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label>Role:</label>
                  <select
                    value={role}
                    onChange={(e) => setRole(e.target.value)}>
                    <option value="member">Member</option>
                    <option value="officer">Officer</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
              <label>User Information</label>
              <div className="userinfo-container">
                <div>
                  <label htmlFor="firstname">First name:</label>
                  <input
                    type="text"
                    placeholder="Enter Firstname"
                    required
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="middlename">Middle Name:</label>
                  <input
                    type="text"
                    placeholder="Enter Middle Name"
                    required
                    value={middlename}
                    onChange={(e) => setMiddlename(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="lastname">Last Name:</label>
                  <input
                    type="text"
                    placeholder="Enter Family Name"
                    required
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="age">Age:</label>
                  <input
                    type="text"
                    placeholder="Enter Age"
                    required
                    value={age}
                    min="0" // Specify minimum age
                    maxLength={3} // Set the maximum length to 3
                    pattern="[0-9]*" // Allow only numeric values
                    onKeyPress={(e) => {
                      // Allow only numeric characters and the Enter key
                      if (isNaN(e.key) && e.key !== "Enter") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      // Remove non-numeric characters
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      );

                      // Update the state with the numeric value
                      setAge(numericValue);
                    }}
                  />
                </div>
                <div>
                  <label htmlFor="Birth-Date">Birth Date:</label>
                  <input
                    type="date"
                    placeholder="Enter Birth-Date"
                    required
                    value={birthdate}
                    onChange={(e) => setBirthdate(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="Gender">Gender:</label>
                  <select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}>
                    <option value="Other">Other</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Lesbian">Lesbian</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="cellnumberNumber">Contant Number:</label>
                  <input
                    type="text"
                    placeholder="Enter cellnumber Number"
                    required
                    pattern="[0-9]{4} [0-9]{3} [0-9]{4}"
                    value={cellnumber}
                    onChange={(e) => {
                      const formattedValue = e.target.value.replace(
                        /[^0-9 ]/g,
                        ""
                      );

                      // Update the state with the formatted value
                      setCellnumber(formattedValue);
                    }}
                  />
                  <small>Format: 0000 000 0000</small>
                </div>
                <div>
                  <label htmlFor="civilstatus">Civil Status:</label>
                  <select
                    value={civilstatus}
                    onChange={(e) => setCivilstatus(e.target.value)}>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Widowed">Widowed</option>
                    <option value="Separated">Separated</option>
                    <option value="Divorced ">Divorced</option>
                    <option value="Annulled ">Annulled</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="religion">Religion:</label>
                  <select
                    value={religion}
                    onChange={(e) => setReligion(e.target.value)}>
                    <option value="Other">Other</option>
                    <option value="Roman Catholic">Roman Catholic</option>
                    <option value="Iglesia ni Cristo">INC</option>
                    <option value="Evangelicals">Evangelicals</option>
                    <option value="Baptists">Baptists</option>
                    <option value="Methodists">Methodists</option>
                    <option value="Seventh-day Adventists">SDA</option>
                    <option value="Pentecostals">Pentecostals</option>
                    <option value="Jehovah's Witnesses">
                      Jehovah's Witnesses
                    </option>
                    <option value="Assemble of God">Assemble of God</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="Nationality">Nationality:</label>
                  <select
                    value={nationality}
                    onChange={(e) => setNationality(e.target.value)}>
                    <option value="Filipino">Filipino</option>
                    <option value="American">American</option>
                    <option value="Chinese">Chinese</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Korean">Korean</option>
                    <option value="Indian">Indian</option>
                    <option value="Australian">Australian</option>
                    <option value="British">British</option>
                    <option value="Ohter">Ohter</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="occupation">Occupation:</label>
                  <select
                    value={occupation}
                    onChange={(e) => setOccupation(e.target.value)}>
                    <option value="None">None</option>
                    <option value="Labor">Labor</option>
                    <option value="HouseWife">HouseWife</option>
                    <option value="Teacher">Teacher</option>
                    <option value="Principal">Principal</option>
                    <option value="Professor">Professor</option>
                    <option value="Librarian">Librarian</option>
                    <option value="Special Education Teacher">
                      Special Education Teacher
                    </option>
                    <option value="Academic Advisor">Academic Advisor</option>
                    <option value="Software Engineer">Software Engineer</option>
                    <option value="Mechanical Engineer">
                      Mechanical Engineer
                    </option>
                    <option value="Civil Engineer">Civil Engineer</option>
                    <option value="Electrical Engineer">
                      Electrical Engineer
                    </option>
                    <option value="Chemical Engineer">Chemical Engineer</option>
                    <option value="Biomedical Engineer">
                      Biomedical Engineer
                    </option>
                    <option value="Data Scientist">Data Scientist</option>
                    <option value="Network Administrator">
                      Network Administrator
                    </option>
                    <option value="IT Support Specialist">
                      IT Support Specialist
                    </option>
                    <option value="Systems Analyst">Systems Analyst</option>
                    <option value="Doctor">Doctor</option>
                    <option value="Nurse">Nurse</option>
                    <option value="Pharmacist">Pharmacist</option>
                    <option value="Physical Therapist">
                      Physical Therapist
                    </option>
                    <option value="Medical Technologist">
                      Medical Technologist
                    </option>
                    <option value="Radiologic Technologist">
                      Radiologic Technologist
                    </option>
                    <option value="Occupational Therapist">
                      Occupational Therapist
                    </option>
                    <option value="Accountant">Accountant</option>
                    <option value="Financial Advisor">Financial Advisor</option>
                    <option value="Marketing Manager">Marketing Manager</option>
                    <option value="Sales Manager">Sales Manager</option>
                    <option value="Human Resources Manager">
                      Human Resources Manager
                    </option>
                    <option value="Operations Manager">
                      Operations Manager
                    </option>
                    <option value="Entrepreneur">Entrepreneur</option>
                    <option value="Consultant">Consultant</option>
                    <option value="Project Manager">Project Manager</option>
                    <option value="Farmer">Farmer</option>
                    <option value="Agricultural Scientist">
                      Agricultural Scientist
                    </option>
                    <option value="Agronomist">Agronomist</option>
                    <option value="Veterinarian">Veterinarian</option>
                    <option value="Poultry Farmer">Poultry Farmer</option>
                    <option value="Lawyer">Lawyer</option>
                    <option value="Judge">Judge</option>
                    <option value="Police Officer">Police Officer</option>
                    <option value="Firefighter">Firefighter</option>
                    <option value="Security Guard">Security Guard</option>
                    <option value="Detective">Detective</option>
                    <option value="Forensic Scientist">
                      Forensic Scientist
                    </option>
                    <option value="Graphic Designer">Graphic Designer</option>
                    <option value="Journalist">Journalist</option>
                    <option value="Photographer">Photographer</option>
                    <option value="Electrician">Electrician</option>
                    <option value="Plumber">Plumber</option>
                    <option value="Welder">Welder</option>
                    <option value="Mason">Mason</option>
                    <option value="Construction Manager">
                      Construction Manager
                    </option>
                    <option value="Painter">Painter</option>
                    <option value="Heavy Equipment Operator">
                      Heavy Equipment Operator
                    </option>
                    <option value="HVAC Technician">HVAC Technician</option>
                    <option value="Housekeeper">Housekeeper</option>
                    <option value="Bartender">Bartender</option>
                    <option value="Store Manager">Store Manager</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="recentaddress">Recentaddress:</label>
                  <input
                    type="text"
                    value={recentaddress}
                    required
                    onChange={(e) => setRecentaddress(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="presentaddress">Presentaddress:</label>
                  <input
                    type="text"
                    required
                    value={presentaddress}
                    onChange={(e) => setPresentaddress(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="Status">Status:</label>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}>
                    <option value="active">Active</option>
                    <option value="unactive">Unactive</option>
                    <option value="blocklist">Block User</option>
                  </select>
                </div>
              </div>
              <span className="btn-container">
                <button className="updatebtn" type="submit">
                  Update
                </button>
                <button
                  className="closebtn"
                  type="button"
                  onClick={handleCancel}>
                  X
                </button>
              </span>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Listalluser;
